import * as React from 'react';
import { connect } from 'react-redux';

import { ModalFrame, ModalFrameFooter, ModalOpener } from 'components/modal';

import CreateNewProfilesConfirmationModalButtons from './components/create-new-profiles-confirmation-modal-buttons/CreateNewProfilesConfirmationModalButtons';
import CreateNewProfilesForCustomCollectionConfirmationModal from './components/create-new-profiles-for-custom-collection-confirmation-modal/CreateNewProfilesForCustomCollectionConfirmationModal';
import CreateNewProfilesForSmartCollectionConfirmationModal from './components/create-new-profiles-for-smart-collection-confirmation-modal/CreateNewProfilesForSmartCollectionConfirmationModal';

import {
  saveToCustomCollection
} from 'modules/create-new-profiles/reducers/actions';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./create-new-profiles-confirmation-modal.i18n.json'));

import { State } from 'types';
import { CreateNewProfilesOpenedOn } from 'modules/create-new-profiles/types/CreateNewProfiles.type';

interface StateProps {
  openedOn: CreateNewProfilesOpenedOn,
  isOpen: boolean
}

interface DispatchProps {
  dispatchOnClose: () => void
}

type Props = StateProps & DispatchProps;

const CreateNewProfilesConfirmationModal = ({
  openedOn,
  isOpen,
  dispatchOnClose
}: Props): JSX.Element => (
  <ModalOpener
    showClose
    open={isOpen}
    onClose={dispatchOnClose}
  >
    <ModalFrame
      classNameFrame="create-new-profiles-add-to-collection-modal__frame"
      title={__t('create_new_profiles_confirmation_modal.title')}
    >
      {openedOn === 'custom-collection' ? (
        <CreateNewProfilesForCustomCollectionConfirmationModal />
      ) : (
        <CreateNewProfilesForSmartCollectionConfirmationModal />
      )}
      <ModalFrameFooter>
        <CreateNewProfilesConfirmationModalButtons />
      </ModalFrameFooter>
    </ModalFrame>
  </ModalOpener>
);

const mapStateToProps = ({ createNewProfiles }: State): StateProps => {
  const { activeModal, confirmationModal, openedOn } = createNewProfiles;

  return {
    openedOn,
    isOpen: activeModal === 'confirmation' && confirmationModal !== null
  };
};

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchOnClose: () => dispatch(saveToCustomCollection())
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewProfilesConfirmationModal);
